import { getComplianceConfig } from 'shared/core/helpers/compliance';

export const useHideSalesLanguage = (dispensaryState?: string | null): boolean => {
  const hideSalesLanguage = dispensaryState ? getComplianceConfig(dispensaryState, 'hideSalesLanguage') : false;

  return hideSalesLanguage;
};
